import React from 'react';
import { IMAGES } from '../utils/constants';
import { scrollToOffer } from '../utils/scroll';
export function HeroSection() {
  return <section className="pt-28 pb-16 px-4 bg-gradient-to-b from-blue-50 to-white overflow-hidden" data-id="element-125">
      <div className="max-w-5xl mx-auto text-center" data-id="element-126">
        <h1 className="text-4xl md:text-6xl font-extrabold text-blue-900 leading-tight mb-6" data-id="element-127">
          🎼 Trasforma le Tue Lezioni di Musica in un'Esperienza{' '}
          <span className="text-blue-600" data-id="element-128">Coinvolgente</span> che i Tuoi
          Studenti Ameranno
        </h1>

        <p className="text-xl md:text-2xl text-gray-700 max-w-3xl mx-auto mb-12 leading-relaxed" data-id="element-129">
          Scopri il sistema pratico e completo che ti aiuta a creare lezioni più
          efficaci, studenti più motivati e progressi reali, senza perdere ore a
          improvvisare ogni settimana.
        </p>

        {/* Fan Image Layout */}
        <div className="relative h-[250px] sm:h-[350px] md:h-[450px] max-w-4xl mx-auto flex items-center justify-center group cursor-pointer mb-8" onClick={scrollToOffer} data-id="element-130">
          {/* Position 1 (Far Left) */}
          <img src={IMAGES.TOMO_2} alt="Bonus 1" className="absolute w-[18%] md:w-[20%] left-[5%] md:left-[10%] -rotate-8 group-hover:-translate-x-6 group-hover:-rotate-12 transition-all duration-500" data-id="element-131" />

          {/* Position 2 (Left) */}
          <img src={IMAGES.TOMO_3} alt="Bonus 2" className="absolute w-[20%] md:w-[22%] left-[18%] md:left-[22%] -rotate-4 group-hover:-translate-x-4 group-hover:-rotate-6 transition-all duration-500 z-10" data-id="element-132" />

          {/* Position 4 (Right) */}
          <img src={IMAGES.TOMO_5} alt="Bonus 3" className="absolute w-[20%] md:w-[22%] right-[18%] md:right-[22%] rotate-4 group-hover:translate-x-4 group-hover:rotate-6 transition-all duration-500 z-10" data-id="element-133" />

          {/* Position 5 (Far Right) */}
          <img src={IMAGES.TOMO_2} alt="Bonus 4" className="absolute w-[18%] md:w-[20%] right-[5%] md:right-[10%] rotate-8 group-hover:translate-x-6 group-hover:rotate-12 transition-all duration-500" data-id="element-134" />

          {/* Position 3 (Main Center) */}
          <img src={IMAGES.TOMO_1} alt="MegaPack Maestro Musicale 360" className="absolute w-[30%] md:w-[32%] z-20 group-hover:scale-105 group-hover:-translate-y-2 transition-all duration-500" data-id="element-135" />
        </div>

        <p className="text-lg font-semibold text-gray-800 mb-8" data-id="element-136">
          5 Risorse + 4 Bonus Gratuiti
        </p>

        <button onClick={scrollToOffer} className="bg-green-500 hover:bg-green-600 text-white rounded-full py-5 px-10 font-bold text-xl md:text-2xl animate-pulse-fast shadow-lg shadow-green-500/30 transition-all transform hover:scale-105" data-id="element-137">
          👉 Accedi Ora al MegaPack
        </button>
      </div>
    </section>;
}